import { Option } from '@common-fe/common-fe';

export const EMPTY_FIELD_VALUE = '—';
export const EMPTY_FILE_FIELD_VALUE = '?';
export const EMPTY_STATE_TEXT = '-';
export const MASKED_CARD_NUMBER = '••••';
export const TITLE = 'Admin Portal';

export const EASTERN_TZ_KEY = 'America/New_York';

export enum PlanStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
}

export const INFINITE_DATE = '01/01/9999';
export const SORT_OPTIONS: Option[] = [
  {
    key: 'ASC',
    value: 'Ascending',
  },
  {
    key: 'DESC',
    value: 'Descending',
  },
];

export const ERROR_ELEMENT_SCROLL_CLASS_NAME = 'ERROR_ELEMENT_SCROLL_CLASS_NAME';

export enum PermissionState {
  VIEW = 'LOCKED',
  HIDE = 'HIDDEN',
  EDIT = 'MODIFIABLE',
}
export enum PermissionKey {
  ABOUT_US_LINK = 'ABOUT_US_LINK',
  AI_CONFIDENCE_LEVEL = 'AI_CONFIDENCE_LEVEL',
  BIN_SETUP = 'BIN_SETUP',
  CARD_EMPLOYER_NAME = 'CARD_EMPLOYER_NAME',
  CARD_PHONE_NUMBER = 'CARD_PHONE_NUMBER',
  CARD_PROCESSOR = 'CARD_PROCESSOR',
  CARD_SETTLEMENT_CLEARING_ACCOUNT_ID = 'CARD_SETTLEMENT_CLEARING_ACCOUNT_ID',
  CARD_URL = 'CARD_URL',
  CHECK_FUNDING_MODEL = 'CHECK_FUNDING_MODEL',
  COMMUNICATION_CATEGORIES = 'COMMUNICATION_CATEGORIES',
  COMMUNICATION_CHANNELS = 'COMMUNICATION_CHANNELS',
  CUSTOMER_SERVICE_EMAIL = 'CUSTOMER_SERVICE_EMAIL',
  CUSTOMER_SERVICE_NUMBER = 'CUSTOMER_SERVICE_NUMBER',
  CUSTOMER_SERVICE_URL_LINK = 'CUSTOMER_SERVICE_URL_LINK',
  CUSTOMER_SERVICE_URL_NAME = 'CUSTOMER_SERVICE_URL_NAME',
  EE_CONTRIBUTIONS_HOLD_PERIOD = 'EE_CONTRIBUTIONS_HOLD_PERIOD',
  ELECTRONIC_FUNDING_MODE = 'ELECTRONIC_FUNDING_MODE',
  ELEVATE_INTEREST_SOURCE_ACCOUNT_ID = 'ELEVATE_INTEREST_SOURCE_ACCOUNT_ID',
  EMAIL_DOMAIN = 'EMAIL_DOMAIN',
  EMAIL_ILLUSTRATION_ID = 'EMAIL_ILLUSTRATION_ID',
  EMAIL_LOGO_PATH = 'EMAIL_LOGO_PATH',
  EMAIL_LOGO_TYPE = 'EMAIL_LOGO_TYPE',
  EMAIL_TEMPLATE_TYPE = 'EMAIL_TEMPLATE_TYPE',
  EMAIL_THEME_ID = 'EMAIL_THEME_ID',
  EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT_METHOD = 'EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT_METHOD',
  EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT = 'EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT',
  EXTERNAL_PAYROLL_CONTRIBUTIONS_ACCOUNT_METHOD = 'EXTERNAL_PAYROLL_CONTRIBUTIONS_ACCOUNT_METHOD',
  EXTERNAL_REPLENISHMENT_ACCOUNT_METHOD = 'EXTERNAL_REPLENISHMENT_ACCOUNT_METHOD',
  FAVICON_LOGO_PATH = 'FAVICON_LOGO_PATH',
  HSA_CUSTODIAN_TYPE = 'HSA_CUSTODIAN_TYPE',
  DEPOSITORY_BANK_CONFIG_TYPE = 'DEPOSITORY_BANK_CONFIG_TYPE',
  ID_SOURCE_TYPE = 'ID_SOURCE_TYPE',
  INTEREST_CLEARING_ACCOUNT_ID = 'INTEREST_CLEARING_ACCOUNT_ID',
  IS_AI_ADJUDICATION = 'IS_AI_ADJUDICATION',
  SIGIS_AUTO_APPROVE = 'SIGIS_AUTO_APPROVE',
  IS_BILL_PAY_ALLOWED = 'IS_BILL_PAY_ALLOWED',
  IS_CARD_OFFERED = 'IS_CARD_OFFERED',
  IS_CUSTOMER_SERVICE_ENABLED = 'IS_CUSTOMER_SERVICE_ENABLED',
  EXPRESS_SETUP_ENABLED = 'EXPRESS_SETUP_ENABLED',
  IS_DEPENDENT_CARD_ALLOWED = 'IS_DEPENDENT_CARD_ALLOWED',
  IS_FILE_AUTO_POST_ENABLED = 'IS_FILE_AUTO_POST_ENABLED',
  IS_FILE_MANAGER_ACCESS_ENABLED = 'IS_FILE_MANAGER_ACCESS_ENABLED',
  IS_REIMBURSEMENT_ALLOWED = 'IS_REIMBURSEMENT_ALLOWED',
  LARGE_LOGO_PATH = 'LARGE_LOGO_PATH',
  LOGO = 'LOGO',
  MINIMIZED_LOGO_PATH = 'MINIMIZED_LOGO_PATH',
  MINIMUM_PAYMENT_REIMBURSEMENT_AMOUNT = 'MINIMUM_PAYMENT_REIMBURSEMENT_AMOUNT',
  NUMBER_DAYS_BEFORE_PLAN_START = 'NUMBER_DAYS_BEFORE_PLAN_START',
  OUTGOING_CLEARING_ACCOUNT_ID = 'OUTGOING_CLEARING_ACCOUNT_ID',
  PAYROLL_CONTRIBUTIONS_HOLD_PERIOD = 'PAYROLL_CONTRIBUTIONS_HOLD_PERIOD',
  PREFUND_REPLENISHMENT_CREEP_MIN = 'PREFUND_REPLENISHMENT_CREEP_MIN',
  PREFUND_REPLENISHMENT_CREEP_PERCENT = 'PREFUND_REPLENISHMENT_CREEP_PERCENT',
  PREFUND_REPLENISHMENT_MIN_VALUE = 'PREFUND_REPLENISHMENT_MIN_VALUE',
  PREFUND_REPLENISHMENT_PERCENT = 'PREFUND_REPLENISHMENT_PERCENT',
  PRIN_SETUP = 'PRIN_SETUP',
  RECURRING_CARD_SWIPES = 'RECURRING_CARD_SWIPES',
  PRIVACY_POLICY_LINK = 'PRIVACY_POLICY_LINK',
  REPLENISHMENT_DAY_NUMBER = 'REPLENISHMENT_DAY_NUMBER',
  REPLENISHMENT_FREQUENCY_TYPE = 'REPLENISHMENT_FREQUENCY_TYPE',
  ROOT_EXTERNAL_ACCOUNT_ID = 'ROOT_EXTERNAL_ACCOUNT_ID',
  SESSION_TIMEOUT_LOGOUT = 'SESSION_TIMEOUT_LOGOUT',
  SESSION_TIMEOUT_WARN = 'SESSION_TIMEOUT_WARN',
  SSO_ONLY = 'SSO_ONLY',
  ADMIN_SSO_ONLY = 'ADMIN_SSO_ONLY',
  STATEMENT_FREQUENCY_TYPE = 'STATEMENT_FREQUENCY_TYPE',
  STATEMENT_TYPE = 'STATEMENT_TYPE',
  TERMS_AND_CONDITIONS_LINK = 'TERMS_AND_CONDITIONS_LINK',
  THEME_TYPE = 'THEME_TYPE',
  TRUE_SSN = 'TRUE_SSN',
  URL = 'URL',
  WAITING_FOR_FUNDS_CONTINUE_PAYMENT = 'WAITING_FOR_FUNDS_CONTINUE_PAYMENT',
  WAITING_FOR_FUNDS_EXPIRATION = 'WAITING_FOR_FUNDS_EXPIRATION',
  DAYS_TO_PEND_RETURNED_CHECKS = 'DAYS_TO_PEND_RETURNED_CHECKS',
  CLAIMS_ASSIGNMENT_NUMBER = 'CLAIMS_ASSIGNMENT_NUMBER',
  IS_CLAIM_OFFSETS_ALLOWED = 'IS_CLAIM_OFFSETS_ALLOWED',
  CLAIM_OFFSET_LOGIC = 'CLAIM_OFFSET_LOGIC',
  ALLOW_PREFUND = 'ALLOW_PREFUND',
  IS_ORGANIZATION_ORPHAN = 'IS_ORGANIZATION_ORPHAN',
  ORPHAN_START_TIMING_DAYS = 'ORPHAN_START_TIMING_DAYS',
  ORPHAN_ORGANIZATION_ID = 'ORPHAN_ORGANIZATION_ID',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  CONTRIBUTION_PUSH_GIVE_UP_DAYS = 'CONTRIBUTION_PUSH_GIVE_UP_DAYS',
  ALLOW_EMPLOYEES_TO_EDIT_ADDRESS = 'ALLOW_EMPLOYEES_TO_EDIT_ADDRESS',
  PRICING_CONSENT = 'PRICING_CONSENT',
  AUTHENTICATION_TYPE = 'AUTHENTICATION_TYPE',
  ACCOUNT_LOCKOUT_TIME = 'ACCOUNT_LOCKOUT_TIME',
  ALLOW_MANUAL_CONTRIBUTION = 'ALLOW_MANUAL_CONTRIBUTION',
  ALLOW_SCHEDULED_CONTRIBUTION = 'ALLOW_SCHEDULED_CONTRIBUTION',
  ALLOW_DEPENDENT_CARD = 'ALLOW_DEPENDENT_CARD',
  CARD_PROCESSING_START_DATE = 'CARD_PROCESSING_START_DATE',
  FILE_LOCATION = 'FILE_LOCATION',
  NOTES = 'NOTES',
  ALLOW_RENEWALS = 'ALLOW_RENEWALS',

  TAX_ID = 'TAX_ID',
  IMPLEMENTATION_MANAGER_ID = 'IMPLEMENTATION_MANAGER_ID',
  INVOICING_CONTACT_ID = 'INVOICING_CONTACT_ID',
  DARK_LARGE_LOGO_PATH = 'DARK_LARGE_LOGO_PATH',
  DARK_MINIMIZED_LOGO_PATH = 'DARK_MINIMIZED_LOGO_PATH',

  PARTICIPANT_CHATBOT_LINK = 'PARTICIPANT_CHATBOT_LINK',
  ADMIN_CHATBOT_LINK = 'ADMIN_CHATBOT_LINK',
  ZENDESK_SSO_ENABLED = 'ZENDESK_SSO_ENABLED',
  WORKING_HOURS = 'WORKING_HOURS',
  AUTOMATED_ORG_LOCK_ENABLED = 'AUTOMATED_ORG_LOCK_ENABLED',
  EXTERNAL_BALANCE_ADJUSTMENT_ACCOUNT_METHOD = 'EXTERNAL_BALANCE_ADJUSTMENT_ACCOUNT_METHOD',
  BALANCE_ADJUSTMENT_HOLD_PERIOD = 'BALANCE_ADJUSTMENT_HOLD_PERIOD',
  BALANCE_ADJUSTMENT_PUSH_GIVE_UP_DAYS = 'BALANCE_ADJUSTMENT_PUSH_GIVE_UP_DAYS',
}
export type OverridablePropertiesPermissions = {
  [key in PermissionKey]?: PermissionState;
};

export enum FieldState {
  MODIFIABLE = 'MODIFIABLE',
  HIDDEN = 'HIDDEN',
  LOCKED = 'LOCKED',
}
export enum FieldStateKey {
  DARK_LARGE_LOGO_PATH = 'DARK_LARGE_LOGO_PATH',
  RESERVATION_CODE = 'RESERVATION_CODE',
  AI_CONFIDENCE_LEVEL = 'AI_CONFIDENCE_LEVEL',
  IS_CUSTOM_REPORTING_FIELD_2_ENABLED = 'IS_CUSTOM_REPORTING_FIELD_2_ENABLED',
  WAITING_FOR_FUNDS_CONTINUE_PAYMENT = 'WAITING_FOR_FUNDS_CONTINUE_PAYMENT',
  ADMIN_PREFUND_PULL = 'ADMIN_PREFUND_PULL',
  CARD_PROCESSOR = 'CARD_PROCESSOR',
  WAITING_FOR_FUNDS_EXPIRATION = 'WAITING_FOR_FUNDS_EXPIRATION',
  DAYS_TO_PEND_RETURNED_CHECKS = 'DAYS_TO_PEND_RETURNED_CHECKS',
  ADMIN_ELECTION_NEEDED = 'ADMIN_ELECTION_NEEDED',
  ADMIN_COMPLETE_SETUP = 'ADMIN_COMPLETE_SETUP',
  CARD_SETTLEMENT_CLEARING_ACCOUNT_ID = 'CARD_SETTLEMENT_CLEARING_ACCOUNT_ID',
  ADMIN_CONTRIBUTION_INVOICE_READY_PULL = 'ADMIN_CONTRIBUTION_INVOICE_READY_PULL',
  OUTGOING_CLEARING_ACCOUNT_ID = 'OUTGOING_CLEARING_ACCOUNT_ID',
  EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT_METHOD = 'EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT_METHOD',
  EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT = 'EXTERNAL_ADMINISTRATOR_FEES_ACCOUNT',
  SESSION_TIMEOUT_WARN = 'SESSION_TIMEOUT_WARN',
  PREFUND_REPLENISHMENT_PERCENT = 'PREFUND_REPLENISHMENT_PERCENT',
  EE_CONTRIBUTIONS_HOLD_PERIOD = 'EE_CONTRIBUTIONS_HOLD_PERIOD',
  TRUE_SSN = 'TRUE_SSN',
  ALLOW_EMPLOYEES_TO_EDIT_ADDRESS = 'ALLOW_EMPLOYEES_TO_EDIT_ADDRESS',
  ADMIN_CONTRIBUTION_INVOICE_READY_PUSH = 'ADMIN_CONTRIBUTION_INVOICE_READY_PUSH',
  SSO_ONLY = 'SSO_ONLY',
  ADMIN_SSO_ONLY = 'ADMIN_SSO_ONLY',
  ADMIN_SCHEDULED_CONTRIBUTION = 'ADMIN_SCHEDULED_CONTRIBUTION',
  PARTICIPANT_STATEMENT_GENERATED = 'PARTICIPANT_STATEMENT_GENERATED',
  IS_AI_ADJUDICATION = 'IS_AI_ADJUDICATION',
  SIGIS_AUTO_APPROVE = 'SIGIS_AUTO_APPROVE',
  PARTICIPANT_CONTACT_INFO_UPDATED = 'PARTICIPANT_CONTACT_INFO_UPDATED',
  EMAIL_ILLUSTRATION_ID = 'EMAIL_ILLUSTRATION_ID',
  PARTICIPANT_CLAIM_ACTIVITY = 'PARTICIPANT_CLAIM_ACTIVITY',
  MINIMUM_PAYMENT_REIMBURSEMENT_AMOUNT = 'MINIMUM_PAYMENT_REIMBURSEMENT_AMOUNT',
  PARTICIPANT_CARD_STATUS_CHANGE = 'PARTICIPANT_CARD_STATUS_CHANGE',
  PARTICIPANT_PORTAL_LINK = 'PARTICIPANT_PORTAL_LINK',
  ADMIN_FILE_PROCESSED = 'ADMIN_FILE_PROCESSED',
  PARTICIPANT_AUTOMATIC_INVESTMENTS = 'PARTICIPANT_AUTOMATIC_INVESTMENTS',
  PARTICIPANT_CHECK_EXPIRED = 'PARTICIPANT_CHECK_EXPIRED',
  EMAIL_DOMAIN = 'EMAIL_DOMAIN',
  CUSTOM_REPORTING_FIELD_3_NAME = 'CUSTOM_REPORTING_FIELD_3_NAME',
  PREFUND_REPLENISHMENT_MIN_VALUE = 'PREFUND_REPLENISHMENT_MIN_VALUE',
  PREFUND_REPLENISHMENT_CREEP_PERCENT = 'PREFUND_REPLENISHMENT_CREEP_PERCENT',
  PARTICIPANT_MFA = 'PARTICIPANT_MFA',
  PARTICIPANT_TRIGGER = 'PARTICIPANT_TRIGGER',
  IS_CUSTOM_REPORTING_FIELD_1_ENABLED = 'IS_CUSTOM_REPORTING_FIELD_1_ENABLED',
  URL = 'URL',
  PARTICIPANT_PAYMENT_METHOD_CHANGE = 'PARTICIPANT_PAYMENT_METHOD_CHANGE',
  IS_CUSTOM_REPORTING_FIELD_5_ENABLED = 'IS_CUSTOM_REPORTING_FIELD_5_ENABLED',
  PARTICIPANT_FAILED_REIMBURSEMENT = 'PARTICIPANT_FAILED_REIMBURSEMENT',
  ABOUT_US_LINK = 'ABOUT_US_LINK',
  PARTICIPANT_BALANCE_REMINDER_INITIAL = 'PARTICIPANT_BALANCE_REMINDER_INITIAL',
  CUSTOMER_SERVICE_URL_NAME = 'CUSTOMER_SERVICE_URL_NAME',
  CUSTOM_REPORTING_FIELD_2_NAME = 'CUSTOM_REPORTING_FIELD_2_NAME',
  PARTICIPANT_CLAIM_ACTIVITY_NO_ACTION = 'PARTICIPANT_CLAIM_ACTIVITY_NO_ACTION',
  PARTICIPANT_ORPHAN = 'PARTICIPANT_ORPHAN',
  ALLOW_MANUAL_CONTRIBUTION = 'ALLOW_MANUAL_CONTRIBUTION',
  ADMIN_REPLENISHMENT_INVOICE_READY_PULL = 'ADMIN_REPLENISHMENT_INVOICE_READY_PULL',
  PRIVACY_POLICY_LINK = 'PRIVACY_POLICY_LINK',
  IS_CUSTOMER_SERVICE_ENABLED = 'IS_CUSTOMER_SERVICE_ENABLED',
  EXPRESS_SETUP_ENABLED = 'EXPRESS_SETUP_ENABLED',
  IS_ORGANIZATION_ORPHAN = 'IS_ORGANIZATION_ORPHAN',
  HSA_CUSTODIAN_TYPE = 'HSA_CUSTODIAN_TYPE',
  DEPOSITORY_BANK_CONFIG_TYPE = 'DEPOSITORY_BANK_CONFIG_TYPE',
  INTEREST_CLEARING_ACCOUNT_ID = 'INTEREST_CLEARING_ACCOUNT_ID',
  SESSION_TIMEOUT_LOGOUT = 'SESSION_TIMEOUT_LOGOUT',
  CARD_PROCESSING_START_DATE = 'CARD_PROCESSING_START_DATE',
  ADMIN_RESET_PASSWORD = 'ADMIN_RESET_PASSWORD',
  ADMIN_REPLENISHMENT_INVOICE_READY_PUSH = 'ADMIN_REPLENISHMENT_INVOICE_READY_PUSH',
  ADMIN_ACH_REJECTED = 'ADMIN_ACH_REJECTED',
  PAYROLL_CONTRIBUTIONS_HOLD_PERIOD = 'PAYROLL_CONTRIBUTIONS_HOLD_PERIOD',
  PARTNER_MOBILE_APP = 'PARTNER_MOBILE_APP',
  LARGE_LOGO_PATH = 'LARGE_LOGO_PATH',
  THEME_TYPE = 'THEME_TYPE',
  PARTNER_APP_ANDROID_LINK = 'PARTNER_APP_ANDROID_LINK',
  PRICING_CONSENT = 'PRICING_CONSENT',
  PARTNER_APP_IOS_LINK = 'PARTNER_APP_IOS_LINK',
  ADMIN_FORGOT_USERNAME = 'ADMIN_FORGOT_USERNAME',
  LOGO = 'LOGO',
  COMMUNICATION_CHANNELS = 'COMMUNICATION_CHANNELS',
  REPLENISHMENT_DAY_NUMBER = 'REPLENISHMENT_DAY_NUMBER',
  PARTICIPANT_RESET_PASSWORD = 'PARTICIPANT_RESET_PASSWORD',
  EMAIL_LOGO_TYPE = 'EMAIL_LOGO_TYPE',
  CUSTOM_REPORTING_FIELD_5_NAME = 'CUSTOM_REPORTING_FIELD_5_NAME',
  PARTICIPANT_CLAIM_OFFSET = 'PARTICIPANT_CLAIM_OFFSET',
  ROOT_EXTERNAL_ACCOUNT_ID = 'ROOT_EXTERNAL_ACCOUNT_ID',
  IS_CUSTOM_REPORTING_FIELD_4_ENABLED = 'IS_CUSTOM_REPORTING_FIELD_4_ENABLED',
  ALLOW_DEPENDENT_CARD = 'ALLOW_DEPENDENT_CARD',
  MINIMIZED_LOGO_PATH = 'MINIMIZED_LOGO_PATH',
  IS_FILE_AUTO_POST_ENABLED = 'IS_FILE_AUTO_POST_ENABLED',
  CARD_URL = 'CARD_URL',
  ELEVATE_INTEREST_SOURCE_ACCOUNT_ID = 'ELEVATE_INTEREST_SOURCE_ACCOUNT_ID',
  CARD_PHONE_NUMBER = 'CARD_PHONE_NUMBER',
  FILE_LOCATION = 'FILE_LOCATION',
  EXTERNAL_PAYROLL_CONTRIBUTIONS_ACCOUNT_METHOD = 'EXTERNAL_PAYROLL_CONTRIBUTIONS_ACCOUNT_METHOD',
  EMAIL_THEME_ID = 'EMAIL_THEME_ID',
  MFA_CONFIG = 'MFA_CONFIG',
  REPLENISHMENT_FREQUENCY_TYPE = 'REPLENISHMENT_FREQUENCY_TYPE',
  ORPHAN_ORGANIZATION_ID = 'ORPHAN_ORGANIZATION_ID',
  FEE_CARD_INTERCHANGE_ACCOUNT_ID = 'FEE_CARD_INTERCHANGE_ACCOUNT_ID',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  PARTICIPANT_CIP_FAILED = 'PARTICIPANT_CIP_FAILED',
  TERMS_AND_CONDITIONS_LINK = 'TERMS_AND_CONDITIONS_LINK',
  PARTICIPANT_FORGOT_USERNAME = 'PARTICIPANT_FORGOT_USERNAME',
  PARTICIPANT_ACCOUNT_CLOSURE = 'PARTICIPANT_ACCOUNT_CLOSURE',
  CHECK_FUNDING_MODEL = 'CHECK_FUNDING_MODEL',
  ADMIN_PORTAL_LINK = 'ADMIN_PORTAL_LINK',
  CUSTOMER_SERVICE_EMAIL = 'CUSTOMER_SERVICE_EMAIL',
  DARK_MINIMIZED_LOGO_PATH = 'DARK_MINIMIZED_LOGO_PATH',
  ID_SOURCE_TYPE = 'ID_SOURCE_TYPE',
  PARTICIPANT_BALANCE_REMINDER = 'PARTICIPANT_BALANCE_REMINDER',
  STATEMENT_FREQUENCY_TYPE = 'STATEMENT_FREQUENCY_TYPE',
  PARTICIPANT_VERIFY = 'PARTICIPANT_VERIFY',
  IS_BILL_PAY_ALLOWED = 'IS_BILL_PAY_ALLOWED',
  CARD_EMPLOYER_NAME = 'CARD_EMPLOYER_NAME',
  PARTICIPANT_INDIVIDUAL_CONTRIBUTION_FAILED = 'PARTICIPANT_INDIVIDUAL_CONTRIBUTION_FAILED',
  CLAIMS_ASSIGNMENT_NUMBER = 'CLAIMS_ASSIGNMENT_NUMBER',
  IS_CARD_OFFERED = 'IS_CARD_OFFERED',
  BIN_SETUP = 'BIN_SETUP',
  PARTICIPANT_INDIVIDUAL_CONTRIBUTION = 'PARTICIPANT_INDIVIDUAL_CONTRIBUTION',
  PARTICIPANT_CARD_ACTIVATION_REMINDER = 'PARTICIPANT_CARD_ACTIVATION_REMINDER',
  PRIN_SETUP = 'PRIN_SETUP',
  RECURRING_CARD_SWIPES = 'RECURRING_CARD_SWIPES',
  COMMUNICATION_CATEGORIES = 'COMMUNICATION_CATEGORIES',
  ALLOW_SCHEDULED_CONTRIBUTION = 'ALLOW_SCHEDULED_CONTRIBUTION',
  IS_CUSTOM_REPORTING_FIELD_3_ENABLED = 'IS_CUSTOM_REPORTING_FIELD_3_ENABLED',
  ADMIN_WELCOME = 'ADMIN_WELCOME',
  PARTICIPANT_OUTSTANDING_CHECK_REMINDER = 'PARTICIPANT_OUTSTANDING_CHECK_REMINDER',
  STATEMENT_TYPE = 'STATEMENT_TYPE',
  PARTICIPANT_WELCOME = 'PARTICIPANT_WELCOME',
  MOBILE_APP_THEME = 'MOBILE_APP_THEME',
  ORPHAN_START_TIMING_DAYS = 'ORPHAN_START_TIMING_DAYS',
  CUSTOMER_SERVICE_NUMBER = 'CUSTOMER_SERVICE_NUMBER',
  CUSTOMER_SERVICE_URL_LINK = 'CUSTOMER_SERVICE_URL_LINK',
  IS_REIMBURSEMENT_ALLOWED = 'IS_REIMBURSEMENT_ALLOWED',
  CUSTOM_REPORTING_FIELD_1_NAME = 'CUSTOM_REPORTING_FIELD_1_NAME',
  CUSTOM_REPORTING_FIELD_4_NAME = 'CUSTOM_REPORTING_FIELD_4_NAME',
  PARTICIPANT_INDIVIDUAL_CONTRIBUTION_REMINDER = 'PARTICIPANT_INDIVIDUAL_CONTRIBUTION_REMINDER',
  PARTICIPANT_CHECK_VOID = 'PARTICIPANT_CHECK_VOID',
  EMAIL_LOGO_PATH = 'EMAIL_LOGO_PATH',
  PARTICIPANT_EMAIL_VERIFICATION = 'PARTICIPANT_EMAIL_VERIFICATION',
  IS_FILE_MANAGER_ACCESS_ENABLED = 'IS_FILE_MANAGER_ACCESS_ENABLED',
  PREFUND_INITIAL_DELAY_DATE = 'PREFUND_INITIAL_DELAY_DATE',
  PREFUND_REPLENISHMENT_CREEP_MIN = 'PREFUND_REPLENISHMENT_CREEP_MIN',
  IS_CLAIM_OFFSETS_ALLOWED = 'IS_CLAIM_OFFSETS_ALLOWED',
  CLAIM_OFFSET_LOGIC = 'CLAIM_OFFSET_LOGIC',
  FAVICON_LOGO_PATH = 'FAVICON_LOGO_PATH',
  ELECTRONIC_FUNDING_MODE = 'ELECTRONIC_FUNDING_MODE',
  EXTERNAL_REPLENISHMENT_ACCOUNT_METHOD = 'EXTERNAL_REPLENISHMENT_ACCOUNT_METHOD',
  NUMBER_DAYS_BEFORE_PLAN_START = 'NUMBER_DAYS_BEFORE_PLAN_START',
  ALLOW_PREFUND = 'ALLOW_PREFUND',
  CONTRIBUTION_PUSH_GIVE_UP_DAYS = 'CONTRIBUTION_PUSH_GIVE_UP_DAYS',
  AUTHENTICATION_TYPE = 'AUTHENTICATION_TYPE',
  ACCOUNT_LOCKOUT_TIME = 'ACCOUNT_LOCKOUT_TIME',
  NOTES = 'NOTES',
  ALLOW_RENEWALS = 'ALLOW_RENEWALS',

  TAX_ID = 'TAX_ID',
  IMPLEMENTATION_MANAGER_ID = 'IMPLEMENTATION_MANAGER_ID',
  INVOICING_CONTACT_ID = 'INVOICING_CONTACT_ID',

  PARTICIPANT_CHATBOT_LINK = 'PARTICIPANT_CHATBOT_LINK',
  ADMIN_CHATBOT_LINK = 'ADMIN_CHATBOT_LINK',
  ZENDESK_SSO_ENABLED = 'ZENDESK_SSO_ENABLED',
  WORKING_HOURS = 'WORKING_HOURS',
  AUTOMATED_ORG_LOCK_ENABLED = 'AUTOMATED_ORG_LOCK_ENABLED',
  EXTERNAL_BALANCE_ADJUSTMENT_ACCOUNT_METHOD = 'EXTERNAL_BALANCE_ADJUSTMENT_ACCOUNT_METHOD',
  BALANCE_ADJUSTMENT_HOLD_PERIOD = 'BALANCE_ADJUSTMENT_HOLD_PERIOD',
  BALANCE_ADJUSTMENT_PUSH_GIVE_UP_DAYS = 'BALANCE_ADJUSTMENT_PUSH_GIVE_UP_DAYS',
}
export type OverridablePropertiesFieldState = {
  [key in FieldStateKey]: FieldState;
};
export const ALL_OPTION_KEY = 'Null';
export const ALL_OPTION = {
  key: ALL_OPTION_KEY,
  value: 'Null',
  title: 'All',
};

export const COUNTRY_MAP: { [key: number]: string } = {
  1: 'USA',
};

export interface FileImage {
  id: string;
  temporalId: string;
  path: string;
  preview: string;
  name: string;
  type: string;
  blob?: Blob | MediaSource;
  url?: string;
  convertFileId?: string;
}

export enum Roles {
  agent = 'AGENT',
  admin1 = 'ADMIN_1',
  admin2 = 'ADMIN_2',
  admin3 = 'ADMIN_3',
  claimsProcessor1 = 'CLAIMS_PROCESSOR_1',
  claimsProcessor2 = 'CLAIMS_PROCESSOR_2',
  claimsProcessorReview = 'CLAIMS_PROCESSOR_REVIEW',
  claimsProcessorEdit = 'CLAIMS_PROCESSOR_EDIT',
  claimsSupervisor = 'CLAIMS_SUPERVISOR',
  finOps = 'FIN_OPS',
  employee = 'EMPLOYEE',
  superUser = 'SUPER_USER',
  elevateSuperUser = 'ELEVATE_SUPER_USER',

  limitedAccess = 'EMPLOYEE_LIMITED_ACCESS',
  noAccess = 'NO_ACCESS',
}

export const NON_ASSIGNABLE_VALUE = 'N/A';
export const NON_ASSIGNABLE_VALUE_PAYLOAD = -1;

export const SERVER_ERRORS = {
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  SERVER_ERROR: 500,
};

export enum OrganizationTypes {
  company = 'COMPANY',
  partner = 'PARTNER',
  system = 'SYSTEM',
  employee = 'EMPLOYEE',
  employer = 'EMPLOYER',
  distributor = 'DISTRIBUTOR',

  dependent = 'DEPENDENT',

  subsidiary = 'SUBSIDIARY',
  subgroup = 'SUBGROUP',
}

export const CLAIM_AGREEMENT_ERROR_TEXT =
  'Please confirm the claim information submitted is accurate and complete.';

export const FIRST_DAY_NUMBER = '01';
export const INVALID_TEXT = 'The field is invalid';
export const REQUIRED_TEXT = 'This field is required';
export const MUST_BE_GREATER_THAN_ZERO_TEXT = 'Must be greater than $0.00';
export const REQUIRED_NOT_EMPTY = 'This field cannot be empty';
export const CUSTOM_DAY_ERROR_TEXT = 'This number does not match the range of available numbers (1-31)';
export const MAX_LENGTH_TEXT = (count: number) => `This field must be at most ${count} characters`;
export const EMAIL_INVALID_TEXT = 'Email must be valid';
export const DATE_INVALID_TEXT = 'Date must be valid';
export const DATE_INVALID_ALTERNATIVE_TEXT = 'Invalid date';
export const DATE_ONLY_FUTURE_TEXT = 'Must be a future date';
export const REQUIRED_DATE_TEXT = 'Date required';
export const DATE_INVALID_FORMAT = (dateFormat: string) => `Date format must be ${dateFormat}`;
export const PHONE_NUMBER_INVALID_TEXT = 'Not a valid 10-digit US phone number';
export const SSN_INVALID_TEXT = 'SSN should be 9-digit number';
export const INVALID_RANGE_TEXT = (min: number, max: number) =>
  `The field value must be between ${min} - ${max}.`;
export const MUST_BE_GREATER_TEXT = (number: number) => `The field value must be greater then ${number}.`;
export const INTEGER_VALUE_TEXT = 'The entered value must be an integer.';
export const SPECIFIC_FIELD_REQUIRED_TEXT = (fieldName: string) => `${fieldName} is required`;

export const ACTIVITY_TYPE = {
  DENTAL: 'dental',
  VISION: 'vision',
  MEDICAL: 'medical',
  PHARMACY: 'pharmacy',
  OTHER: 'other',
  TUITION: 'tuition',
  FEES: 'fees',
  INTEREST: 'interest',
  ADJUSTMENTS: 'adjustments',
  CONTRIBUTIONS: 'contributions',
  INVESTMENTS: 'investments',
  TRANSIT: 'transit',
  PARKING: 'parking',
  ADOPTION: 'adoption',
  FITTNESS: 'fittnes',
  TRAVEL: 'travel',
};

export const ACCOUNTS_TYPES = {
  HSA: 'hsa',
  FSA: 'fsa',
};

export const MIN_DATE = '1910-01-01';
export const DATE_DOTS_FORMAT = 'MM.DD.YYYY';
export const DATETIME_DOTS_FORMAT = 'MM.DD.YYYY_HH.mm.ss';
export const DATE_MONTH_YEAR_FORMAT = 'MM/YY';
export const SHORT_DATE_FORMAT = 'MM/DD/YY';
export const LAST_DATE_UPDATE_DATE_FORMAT = 'hh:mm A [Eastern on] MM/DD/YYYY';
export const DEFAULT_CARD_EXP_DATE_FORMAT = 'MM/DD/YY';
export const DEBIT_EXP_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'MM/DD/YYYY h:mm a';
export const DEFAULT_DATE_TIME_FORMAT_SHORT = 'MM/DD/YY, h:mm a';
export const YTD_DATE_FORMAT = 'DD-MMM-YYYY';
export const REPORT_DATE_FORMAT = 'MMM DD YYYY';
export const DATE_MASK_TIME = 'DD MMM YYYY _ h:mm A';
export const INPUT_DATE_FORMAT = 'DD MMM YYYY';
export const DATE_MASK_TIME_WITHOUT_YEAR = 'DD MMM _ h:mm a';
export const DATE_MASK_TIME_WITHOUT_YEAR_WITH_AT = 'DD MMM [at] h:mm a';
export const TIME_FORMAT = 'h:mm a';
export const MINIMIZE_DATE_FORMAT = 'MM/DD/YY';
export const DEFAULT_DATE_MASK = '99/99/9999';
export const DEFAULT_INPUT_DATE_FORMAT = 'DD/MM/YYYY';
export const RAW_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TOOLTIP_FORMAT = 'D MMMM YYYY';
export const FULL_MONTH_FORMAT = 'MMMM';
export const FULL_YEAR_FORMAT = 'YYYY';
export const FULL_DAY_OF_WEEK_FORMAT = 'dddd';
export const SHORT_MONTH_FORMAT = 'MMM';
export const MOUNTH_YEAR_FORMAT = 'MMM YYYY';

export const SSN_MASK_WITH_DASHES = '999-99-9999';
export const SSN_MASK_WITHOUT_DASHES = '999999999';

export const TWENTIETH_CENTURY = 20;
export const MINUTE = 60000;
export const SECOND = 1000;
export const COOKIE_NEVER_EXPIRE = 10 * 365 * 24 * 60 * 60;

export const DEFAULT_EMPTY_CHARACTER = '—';
export const EMPTY_LABEL_SIGN = ' ';
export const LOGO_SIZE = '40px';
export const FAV_SIZE = '16px';

export enum LetterIconSizeEnum {
  LOGO = 'logo',
  FAV = 'fav',
}

export const LARGE_SIZE_LOGO = {
  width: 120,
  height: 40,
};

export const SMALL_SIZE_LOGO = {
  width: 80,
  height: 40,
};

export const BOOLEAN_STRINGS = {
  TRUE: 'true',
  FALSE: 'false',
};

export const NOT_NUMBERS_REGEXP = new RegExp(/[^0-9]/, 'g');

export const ERRORS_CODE = {
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  CONFLICT: 409,
  SERVER: 500,
};

export enum CommunicationType {
  IMPORTANT_ONLY = 'IMPORTANT_ONLY',
  INTERESTING = 'INTERESTING',
  ALL_NOTIFICATIONS = 'ALL_NOTIFICATIONS',
}

export enum CommunicationChannelsType {
  NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
  EMAIL_SMS = 'EMAIL_SMS',
}

export const AUTH_ERROR_KEY = {
  WRONG_SSN_OR_DATE:
    'Server cannot process request for specified url. Details: Search criteria common cannot be processed for the passed arguments.',
  PHONE_NUMBER: 'Invalid phone number.',
  USERNAME_WORNG_FORMATE: '1000002',
  ACCOUNT_EXIST: 'Details: Application user with ',
  AUTH_ERROR: 'Authorization has failed or has not yet been provided.',
  AUTH_SECOND_ERROR: 'Authentication has failed or has not yet been provided.',
  CODE_IS_WRONG: 'The code is wrong',
  PASSWORD_MUST_MATCH: 'Passwords must match',
  PASSWORD_IS_REQUIRED: 'Password is required',
  USER_NAME_REQUIRED: 'Username is required',
  USER_FORMAT_INVALID: 'Username format is invalid',
  PASSWORD_DO_NOT_MATCH: 'Passwords do not match. Please make sure both passwords are identical.',
  PASSWORD_INVALID: 'Password is not valid',
  PASSWORD_MUST_BE_DIFFERENT: 'New password must be different from the existing password.',
  PASSWORD_TOO_SHORT: 'At least 8 characters',
  MIXTURE_UPPER_AND_LOWER_CASE: 'A mixture of both uppercase and lowercase letters',
  MIXTURE_LETTERS_AND_NUMBERS: 'A mixture of letters and numbers',
  INCLUSION_ONE_SPECIAL_CHARACTER: 'Inclusion of at least one special character, e.g., !, @, #',
  DOES_NOT_CONTAIN_FORBIDDEN_CHARACTERS: 'Must not contain prohibited characters, e.g., +, _',
  START_OR_END_WITH_SPACE: 'Your password cannot begin or end with a blank space',
  TOO_MANY_FAILED_ATTEMPTS: 'Too many failed attempts. Please try again in a few minutes',
};

export const US_STATES = [
  { key: 'Alabama', value: 'Alabama' },
  { key: 'Alaska', value: 'Alaska' },
  { key: 'Arizona', value: 'Arizona' },
  { key: 'Arkansas', value: 'Arkansas' },
  { key: 'California', value: 'California' },
  { key: 'Colorado', value: 'Colorado' },
  { key: 'Connecticut', value: 'Connecticut' },
  { key: 'Delaware', value: 'Delaware' },
  { key: 'District of Columbia', value: 'District of Columbia' },
  { key: 'Florida', value: 'Florida' },
  { key: 'Georgia', value: 'Georgia' },
  { key: 'Hawaii', value: 'Hawaii' },
  { key: 'Idaho', value: 'Idaho' },
  { key: 'Illinois', value: 'Illinois' },
  { key: 'Indiana', value: 'Indiana' },
  { key: 'Iowa', value: 'Iowa' },
  { key: 'Kansas', value: 'Kansas' },
  { key: 'Kentucky', value: 'Kentucky' },
  { key: 'Louisiana', value: 'Louisiana' },
  { key: 'Maine', value: 'Maine' },
  { key: 'Maryland', value: 'Maryland' },
  { key: 'Massachusetts', value: 'Massachusetts' },
  { key: 'Michigan', value: 'Michigan' },
  { key: 'Minnesota', value: 'Minnesota' },
  { key: 'Mississippi', value: 'Mississippi' },
  { key: 'Missouri', value: 'Missouri' },
  { key: 'Montana', value: 'Montana' },
  { key: 'Nebraska', value: 'Nebraska' },
  { key: 'Nevada', value: 'Nevada' },
  { key: 'New Hampshire', value: 'New Hampshire' },
  { key: 'New Jersey', value: 'New Jersey' },
  { key: 'New Mexico', value: 'New Mexico' },
  { key: 'New York', value: 'New York' },
  { key: 'North Carolina', value: 'North Carolina' },
  { key: 'North Dakota', value: 'North Dakota' },
  { key: 'Ohio', value: 'Ohio' },
  { key: 'Oklahoma', value: 'Oklahoma' },
  { key: 'Oregon', value: 'Oregon' },
  { key: 'Pennsylvania', value: 'Pennsylvania' },
  { key: 'Rhode Island', value: 'Rhode Island' },
  { key: 'South Carolina', value: 'South Carolina' },
  { key: 'South Dakota', value: 'South Dakota' },
  { key: 'Tennessee', value: 'Tennessee' },
  { key: 'Texas', value: 'Texas' },
  { key: 'Utah', value: 'Utah' },
  { key: 'Vermont', value: 'Vermont' },
  { key: 'Virginia', value: 'Virginia' },
  { key: 'Washington', value: 'Washington' },
  { key: 'West Virginia', value: 'West Virginia' },
];

export const SERVER_ERROR_MODAL_TITLE = 'The Server Encountered an Error Processing the Request';
export const SERVER_ERROR_MODAL_TEXT =
  "It doesn't appear to have affected your data, but we cannot proceed with your request. Our technical staff have been automatically notified and will be looking into this with the utmost urgency.";
export const CLAIM_OCR_ERROR_TEXT = 'Please correct the highlighted errors to submit the claim. ';

export enum FileType {
  PDF = 'application/pdf',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
  GIF = 'image/gif',
  SVG = 'image/svg+xml',
  ICO = 'image/x-icon',
  BMP = 'image/bmp',
  HEIC = 'image/heic',
  HEIF = 'image/heif',
  TIF = 'image/tif',
  TIFF = 'image/tiff',
}

export enum FileExtension {
  PDF = '.pdf',
  JPEG = '.jpeg',
  JPG = '.jpg',
  PNG = '.png',
  HEIC = '.heic',
  HEIF = '.heif',
  TIF = '.tif',
  TIFF = '.tiff',
}

export const ACCEPTED_FILE_TYPES = {
  [FileType.PDF]: [FileExtension.PDF],
  [FileType.JPEG]: [FileExtension.JPEG],
  [FileType.JPG]: [FileExtension.JPG],
  [FileType.PNG]: [FileExtension.PNG],
  [FileType.HEIC]: [FileExtension.HEIC],
  [FileType.HEIF]: [FileExtension.HEIF],
  [FileType.TIF]: [FileExtension.TIF],
  [FileType.TIFF]: [FileExtension.TIFF],
};
export const allowedFileTypes = Object.keys(ACCEPTED_FILE_TYPES) as FileType[];
export const allowedExtensions = Object.values(ACCEPTED_FILE_TYPES).flat() as FileExtension[];

export const MAX_SIZE_OF_FILE_IN_MEGABYTES = 20;
export const MAX_SIZE_OF_FILE = MAX_SIZE_OF_FILE_IN_MEGABYTES * 1024 * 1024;
export const ACCEPTED_LOGO_FILE_TYPES = `${FileType.JPEG}, ${FileType.PNG}, ${FileType.GIF}, ${FileType.SVG}, ${FileType.BMP}, ${FileType.JPG}`;
export const ACCEPTED_EMAIL_LOGO_FILE_TYPES = `${FileType.JPEG}, ${FileType.PNG}, ${FileType.SVG}, ${FileType.JPG}`;
export const MAX_LOGO_FILE_SIZE = 4194303;

export enum RequestHeaders {
  observedOrganizationPath = 'Observed-Organization-Path',
  ifMatch = 'If-Match',
}

export const ROOT_ORGANIZATION = '\\0\\';

export const ONE_HUNDRED_PERCENT = 100;

export const YES_KEY = 'yes';
export const NO_KEY = 'no';
export const TRUE_KEY = 'true';
export const FALSE_KEY = 'false';
export const AUTO_SFTP_LOCATION = '/';

export enum FeatureFlagKeys {
  RESEND_COMMUNICATIONS = 'RESEND_COMMUNICATIONS',
  ROLE_BUILDER = 'ROLE_BUILDER',
  TRANSACTION_OCR_MATCHING = 'TRANSACTION_OCR_MATCHING',
  DUPLICATION_CHECK_FILES = 'DUPLICATION_CHECK_FILES',
  SHOW_ELIGIBLE_SERVICES = 'SHOW_ELIGIBLE_SERVICES',
  PLAN_TERMINATION = 'PLAN_TERMINATION',
  PLANS_RENEWAL = 'PLANS_RENEWAL',
  PLANS_RENEWAL_OPTIONS = 'PLANS_RENEWAL_OPTIONS',
  FUNDING_METHODS = 'FUNDING_METHODS',
  PUSH_PROVISIONING = 'PUSH_PROVISIONING',
}

export enum NoteTypes {
  ORG_NOTES = 'ORG',
  HEALTH_PLAN_NOTES = 'HEALTH_PLAN',
  PLAN_NOTES = 'PLAN',
}

export enum ClientType {
  WEB_APP = 'WEB_APP',
  MOBILE_APP = 'MOBILE_APP',
  PARTNER_SSO = 'PARTNER_SSO',
  MANAGE_PROFILE = 'MANAGE_PROFILE',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
}

export enum PromiseStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}

export enum ExternalLink {
  gustoProdLogin = 'https://elevate.auth.us-east-2.amazoncognito.com/oauth2/authorize?identity_provider=Gusto-OKTA-SSO&redirect_uri=https://admin-gusto.elevateaccounts.com&response_type=TOKEN&client_id=3mtiqpfodnepkrbjjvfj3ch6qi&scope=aws.cognito.signin.user.admin%20email%20openid%20profile',
  gustoDemoLogin = 'https://demo-elevate.auth.us-east-2.amazoncognito.com/oauth2/authorize?identity_provider=Gusto-DEMO-OKTA-SSO&redirect_uri=https://admin-gusto.demo.elevateaccounts.com&response_type=token&client_id=54qs7l37ge6j97v4ch5oecgrfq&scope=aws.cognito.signin.user.admin%20email%20openid%20profile',
}
